import { render } from "./AudienceActivityModal.vue?vue&type=template&id=25bed7cc&scoped=true"
import script from "./AudienceActivityModal.vue?vue&type=script&lang=ts"
export * from "./AudienceActivityModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-25bed7cc"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection});
